import { render, staticRenderFns } from "./OrderDetailHotelView.vue?vue&type=template&id=b7504dc0&scoped=true"
import script from "./OrderDetailHotelView.vue?vue&type=script&lang=js"
export * from "./OrderDetailHotelView.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailHotelView.vue?vue&type=style&index=0&id=b7504dc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7504dc0",
  null
  
)

export default component.exports